
VLW.controllers.LesHommesOut = class extends VLW.controllers.Home {
	constructor(a, b) {
		super(a, b);
		this.pixi.align="cc";
		this.pixi.displacementType=VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_TERROIR;
		this.constructor.setStyleMenuHover("color_gris");

	}

	loadPIXIResources(){
		let _loader = new PIXI.loaders.Loader();
		_loader.add("image", this.getPIXIResourcesBackground());
		_loader.add("mask"			, "/images/mask-terroir.png");
		_loader.add("displacement"	, "/images/d3.jpg");
		_loader.load((loader, resources)=>{this.pixi.resources = resources;loader.destroy()});
	}
	
	introContent(){
		super.introContent();
		!VERSION_SMARTP && TweenMax.to("._voileNoir",.75,{opacity:.8,ease:Sine.easeIn,display:"block"});
	}
	
	outro(){
		super.outro();
		TweenMax.killTweensOf("._voileNoir");
		TweenMax.to("._voileNoir",.75,{opacity:0,ease:Sine.easeOut,display:"none"});
	}
};